const {
  getEnvPlids,
  getPlidFromHost,
  getPlidFromDomain,
  getProdPlidFromOte,
  isPrivateLabelHost,
  isSecureServerHost
} = require('./env-plid');

module.exports = {
  getEnvPlids,
  getPlidFromHost,
  getPlidFromDomain,
  getProdPlidFromOte,
  isPrivateLabelHost,
  isSecureServerHost
};
